export default "__VITE_ASSET__B9px93Y2__"